/**
 * 범위 정렬 공유 비교자 — Excel 시맨틱.
 *
 * 세 소비자(ExcelRenderer 수동 정렬 / docAgent applyPatch sortRange 리듀서 /
 * ai xlsx session.sort_range 미러)가 동일한 순서 규칙을 공유한다. Python
 * 미러와의 결과 일치를 위해 로케일 의존 비교(localeCompare)를 쓰지 않는다
 * — 한글 음절은 코드포인트 순서가 사전 순서와 일치한다.
 *
 * 규칙:
 *  1) 빈 값('')은 방향과 무관하게 항상 마지막 (Excel 동일)
 *  2) 양쪽이 유한수로 파싱되면 숫자 비교
 *  3) 그 외 소문자화 문자열의 코드포인트 비교
 *  4) dir==='desc' 는 비어있지 않은 값들 사이에서만 부호 반전
 * 안정 정렬(Array.prototype.sort / Python sorted 모두 stable)과 결합하면
 * 재정렬이 멱등이 된다.
 *
 * 주의: 호출자마다 입력이 다르다 — 수동 정렬은 렌더된 표시 문자열,
 * 리듀서/미러는 IR 저장값(신규 수식 셀은 캐시 없음) — 순서 "규칙"만 공유한다.
 */
export const compareCellsForSort = (
  a: string,
  b: string,
  dir: 'asc' | 'desc',
): number => {
  const aEmpty = a === '';
  const bEmpty = b === '';
  if (aEmpty && bEmpty) return 0;
  if (aEmpty) return 1; // 빈 값은 항상 마지막
  if (bEmpty) return -1;
  const na = Number(a);
  const nb = Number(b);
  let cmp: number;
  if (!Number.isNaN(na) && !Number.isNaN(nb)) {
    cmp = na - nb;
  } else {
    const la = a.toLowerCase();
    const lb = b.toLowerCase();
    cmp = la < lb ? -1 : la > lb ? 1 : 0;
  }
  return dir === 'asc' ? cmp : -cmp;
};
